import { useState } from "react";
import { faqs } from "@/mocks/site";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(faqs[0]?.id ?? null);

  const toggle = (id: number) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-4xl">
        <SectionHeading
          eyebrow="QUESTIONS"
          title="常见问题"
          desc="关于档案的可信度、证据留存与投稿方式，这里集中回答一下。"
          align="center"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <Reveal key={item.id} delay={index * 50}>
                <div className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${isOpen ? "border-primary-300" : "border-background-200"}`}>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-sm font-bold text-primary-500">Q{index + 1}</span>
                      <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.question}</span>
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${isOpen ? "border-primary-400 bg-primary-100 text-primary-700" : "border-background-300 text-foreground-600"}`}>
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base leading-none`}></i>
                    </span>
                  </button>
                  <div
                    className="grid transition-all duration-300 ease-out"
                    style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6 md:pl-[3.4rem]">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}